import { Loader } from 'modules/ui';

import authorizableHOC from './authorizable';

import LoginPage from '../components/LoginPage';

export const authorizedHOC = Component => authorizableHOC(Component, LoginPage, Loader);

export default authorizedHOC;
